// Modules
import React, { useEffect, ReactElement } from 'react'
import { Modal, Button } from '@dasa-health/components-react'
import { useTracking } from 'react-tracking'

// Components
import { PhonesHelpCenter } from '../'
import { ModalContainer, ModalImg, ModalContent, ModalWrapper } from './styles'

export interface HelpModalProps {
    displayButton?: boolean
    showModal: boolean
    setShowModal: React.Dispatch<React.SetStateAction<boolean>>
    image: string
    title: string
    subtitle: string | ReactElement
    secondSubtitle?: string
    PhonesHelpCenterShow?: boolean
    link?: {
        to: string
        text: string
    }
    trackEvent?: {
        event: string
        steps?: string
        path?: string
        reason?: string
        access?: string
    }
    titleFontSize?: string
}

export const HelpModal = (props: HelpModalProps) => {
    const { trackEvent: track } = useTracking()
    const {
        showModal,
        setShowModal,
        image,
        title,
        subtitle,
        secondSubtitle,
        displayButton,
        link,
        trackEvent,
        PhonesHelpCenterShow = true,
        titleFontSize,
    } = props

    useEffect(() => {
        if (trackEvent) {
            track(trackEvent)
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <>
            {showModal && (
                <ModalContainer>
                    <Modal fullMobile={true} onClose={() => setShowModal(false)} open={showModal}>
                        <ModalWrapper>
                            <ModalImg alt="camera" src={image} />
                            <ModalContent sizeTitleMobile={titleFontSize}>
                                <h1 className="modal__title">{title}</h1>
                                <p className="modal__subtitle">{subtitle}</p>
                                {secondSubtitle && <p className="modal__subtitle">{secondSubtitle}</p>}
                                {PhonesHelpCenterShow && <PhonesHelpCenter />}
                                {displayButton && (
                                    <Button data-testid="help-modal-button" onClick={() => setShowModal(false)} variant="primary">
                                        {link?.text}
                                    </Button>
                                )}
                            </ModalContent>
                        </ModalWrapper>
                    </Modal>
                </ModalContainer>
            )}
        </>
    )
}
